import { memo } from "react";
import { Row, Col, Button } from "react-bootstrap";

const HeatmapCombinedSensorList = ({
    onSelectSensor,
    onChange,
    sensors,
}: any) => {
    const sensorList: any[] = [
        {
            key: "Sensor 1",
        },
        {
            key: "Sensor 2",
        },
        {
            key: "Sensor 3",
        },
        {
            key: "Sensor 4",
        },
    ];

    sensorList.forEach((sensor, index) => {
        if (sensors?.[index]) {
            Object.assign(sensor, sensors[index]);
        }
    });

    const handleChangeSensorList = (updatedSensorList: any) => {
        onChange(updatedSensorList);
    };

    const handleSelectSensor = (selectedSensors: any, currentKey: string) => {
        const selectedSensor = Object.values(selectedSensors)[0] as any;
        if (!selectedSensor) {
            return;
        }

        const index = sensorList.findIndex((item) => item.key === currentKey);
        const updatedSensorList = [...sensorList];
        updatedSensorList[index] = {
            ...updatedSensorList[index],
            ...selectedSensor,
        };

        handleChangeSensorList(updatedSensorList);
    };

    const removeSensor = (sensor: any) => {
        const index = sensorList.findIndex((item) => item.key === sensor.key);
        const updatedSensorList = [...sensorList];
        updatedSensorList[index] = {
            key: sensor.key,
        };

        handleChangeSensorList(updatedSensorList);
    };

    return (
        <Row className="cstm-table heatmap-sensor-table">
            <Col sm={12}>
                <div className="table-head">
                    <Row className="no-checkbox">
                        <Col xs={{ span: 2 }}></Col>
                        <Col xs={{ span: 2 }}>Sensor Name</Col>
                        <Col xs={{ span: 2 }}>Type</Col>
                        <Col xs={{ span: 2 }}>Gateway</Col>
                        <Col xs={{ span: 2 }}>UUID</Col>
                        <Col xs={{ span: 1 }}> </Col>
                    </Row>
                </div>
                {sensorList.map((sensor) => (
                    <div className="table-row" key={sensor.key}>
                        <Row className="no-checkbox">
                            <Col xs={{ span: 2 }}>{sensor.key}</Col>
                            <Col xs={{ span: 2 }}>{sensor.device_name}</Col>
                            <Col xs={{ span: 2 }}>{sensor.sensor_type}</Col>
                            <Col md={{ span: 2 }}>{sensor.gatewayName}</Col>
                            <Col md={{ span: 2 }}>{sensor.gatewayId}</Col>
                            <Col md={{ span: 2 }} className="text-right">
                                {sensor.gatewayId ? (
                                    <Button
                                        variant="link"
                                        className="p-0 text-decoration-none"
                                        onClick={() => removeSensor(sensor)}
                                    >
                                        <i className="material-icons close-icon d-flex">
                                            close
                                        </i>
                                    </Button>
                                ) : (
                                    <Button
                                        variant="primary"
                                        onClick={() => {
                                            if (
                                                typeof onSelectSensor ===
                                                "function"
                                            ) {
                                                onSelectSensor({
                                                    show: true,
                                                    excludeDevices: (
                                                        sensorList || []
                                                    )
                                                        .map(
                                                            (item) =>
                                                                item.device_id
                                                        )
                                                        .filter(Boolean),
                                                    multipleSelection: false,
                                                    handler: (data: any) =>
                                                        handleSelectSensor(
                                                            data,
                                                            sensor.key
                                                        ),
                                                });
                                            }
                                        }}
                                    >
                                        Select Sensor
                                    </Button>
                                )}
                            </Col>
                        </Row>
                    </div>
                ))}
            </Col>
        </Row>
    );
};

export default memo(HeatmapCombinedSensorList);
